import script from "./ImagePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagePicker.vue?vue&type=script&setup=true&lang=js"

import "./ImagePicker.vue?vue&type=style&index=0&id=046cb5ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046cb5ef"]])

export default __exports__